export const en = {
  // Header
  filiales: "Subsidiaries",
  contact: "Contact",
  
  // Hero Section
  heroTitle: "Structure and develop an ",
  heroTitle2: " ecosystem of complementary",
  heroTitle3: "companies.",
  heroDescription: "MSIT Corporate is a multidisciplinary group that federates and pilots ",
  heroDescription2: " several companies specialized in consulting, digital, ",
  heroDescription3: " payroll portage and professional spaces.",
  
  // Groupe Section
  groupeTitle: "1 Group",
  groupeSubtitle: "4 Subsidiaries",
  groupeDescription: "complementary companies united by the same mission: putting expertise at the service of your evolution",
  spotinTitle: "Spotin",
  spotinDescription: "Modern and inspiring spaces to work, collaborate and boost your creativity",
  buzztrackTitle: "Buzztrack",
  buzztrackDescription: "A dedicated team to create your digital identity, boost your visibility and maximize your opportunities.",
  msitConseilTitle: "Msit Conseil",
  msitConseilDescription: "Tailored strategic advice to transform your ambitions into concrete results.",
  matoisTitle: "Matois",
  matoisDescription: "The freedom to work safely with complete administrative and financial support.",
  
  // Corporate Stats
  corporateStatsTitle: "Msit Corporate",
  corporateStatsSubtitle: "in numbers",
  stats1Number: "+4",
  stats1Label: "complementary subsidiaries",
  stats2Number: "50+",
  stats2Label: "employees and partners",
  stats3Number: "70",
  stats3Label: "Projects completed",
  
  // Coworking Section
  matoisCoworkingTitle: "Matois",
  matoisCoworkingText1: "Simplified and secure payroll portage",
  matoisCoworkingText2: "Flexible solutions for independents",
  matoisCoworkingText3: "Integrated HR and administrative management",
  msitConseilCoworkingTitle: "Msit conseil",
  msitConseilCoworkingText1: "Strategy & information systems consulting",
  msitConseilCoworkingText2: "Digital transformation support",
  msitConseilCoworkingText3: "Business & technical expertise",
  msitConseilCoworkingText4: "Strategic vision",
  buzzTrackCoworkingTitle: "Buzz Track",
  buzzTrackCoworkingText1: "360° marketing & communication agency",
  buzzTrackCoworkingText2: "High-performance website creation",
  buzzTrackCoworkingText3: "Tailored digital strategies",
  buzzTrackCoworkingText4: "Brand growth and visibility",
  spotinCoworkingTitle: "Spotin",
  spotinCoworkingText1: "Modern and flexible coworking spaces",
  spotinCoworkingText2: "Private offices & design open spaces",
  spotinCoworkingText3: "All-inclusive professional services",
  
  // Contact Section
  contactTitle: "Questions?",
  contactSubtitle: "We have the answers.",
  contactNamePlaceholder: "First & Last Name",
  contactEmailPlaceholder: "Email address",
  contactMessagePlaceholder: "Message",
  contactAcceptText: "I accept the terms and conditions of the",
  contactPrivacyPolicy: "privacy policy.",
  contactSubmitButton: "Send",
  contactSuccessMessage: "✅ Message sent successfully!",
  contactErrorMessage: "❌ Error sending message.",
  contactNetworkError: "📡 Unable to send message.",
  
  // Footer
  home: "Home",
  msitCorporate: "MSIT CORPORATE",
  msitAdvisory: "MSIT ADVISORY",
  buzzTrack: "Buzz track",
  spotIn: "Spot'in",
  allRightsReserved: "© 2006-2025, MSIT CORPORATE. All Rights Reserved",
  privacyPolicy: "Privacy Policy",
  cookiesPolicy: "Cookies Policy",
  
  // Cookies Policy
  cookiesTitle: "Cookies Policy",
  cookiesLastUpdated: "Last updated:",
  cookiesLead: "This Cookies Policy explains how MSIT Corporate uses cookies and similar technologies on our website.",
  cookiesWhatAre: "1. What Are Cookies?",
  cookiesWhatAreText: "Cookies are small text files placed on your device when you visit a website. They help us enhance your user experience and improve our website's performance.",
  cookiesTypes: "2. Types of Cookies We Use",
  cookiesEssential: "Essential cookies:",
  cookiesEssentialText: "Required for the website to function properly.",
  cookiesAnalytics: "Analytics cookies:",
  cookiesAnalyticsText: "Help us understand how visitors use our site (e.g., Google Analytics).",
  cookiesFunctional: "Functional cookies:",
  cookiesFunctionalText: "Remember your preferences and improve usability.",
  cookiesMarketing: "Marketing cookies:",
  cookiesMarketingText: "Used to deliver relevant ads or content (only with your consent).",
  cookiesHowWeUse: "3. How We Use Cookies",
  cookiesUse1: "Ensure proper website functionality.",
  cookiesUse2: "Analyze traffic and improve user experience.",
  cookiesUse3: "Customize content and remember your preferences.",
  cookiesManaging: "4. Managing Cookies",
  cookiesManagingText: "You can manage or disable cookies through your browser settings. Please note that disabling essential cookies may affect the website's functionality.",
  cookiesManagingDetails: "For more details, visit:",
  cookiesUpdates: "5. Updates to This Policy",
  cookiesUpdatesText: "We may revise this Cookies Policy periodically. All changes will be published on this page with the updated date.",

  // Privacy Policy
  privacyTitle: "Privacy Policy",
  privacyLastUpdated: "Last updated:",
  privacyLead: "MSIT Corporate is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal data when you visit our website or interact with our services.",
  privacyInformation: "1. Information We Collect",
  privacyInformationText: "We may collect the following types of information:",
  privacyPersonalInfo: "Personal information:",
  privacyPersonalInfoText: "such as name, email address, phone number, and company details, when you contact us or fill out a form.",
  privacyTechnicalData: "Technical data:",
  privacyTechnicalDataText: "including IP address, browser type, device information, and pages visited.",
  privacyUsageData: "Usage data:",
  privacyUsageDataText: "details about your browsing activity and interaction with our website.",
  privacyHowWeUse: "2. How We Use Your Information",
  privacyHowWeUseText: "We process your personal data to:",
  privacyUse1: "Provide, operate, and improve our services.",
  privacyUse2: "Respond to your inquiries and communication requests.",
  privacyUse3: "Send business updates or marketing materials (only with your consent).",
  privacyUse4: "Comply with legal and regulatory obligations.",
  privacyLegalBasis: "3. Legal Basis for Processing",
  privacyLegalBasisText: "We process your data under one or more of the following legal bases:",
  privacyConsent: "Your consent.",
  privacyContract: "Performance of a contract.",
  privacyLegalObligations: "Compliance with legal obligations.",
  privacyLegitimateInterests: "Our legitimate business interests (such as improving services and website performance).",
  privacyRetention: "4. Data Retention",
  privacyRetentionText: "We retain your data only for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law.",
  privacySharing: "5. Data Sharing and Transfers",
  privacySharingText: "We do not sell your personal data. We may share information with:",
  privacySubsidiaries: "Our subsidiaries and affiliated entities (MSIT Advisory, Buzztrack, Matois, Spotin).",
  privacyServiceProviders: "Service providers that assist us in operating our website and services.",
  privacyLegalAuthorities: "Legal authorities if required by applicable law.",
  privacySecurity: "6. Data Security",
  privacySecurityText: "We use industry-standard technical and organizational measures to protect your information from unauthorized access, loss, misuse, or alteration.",
  privacyRights: "7. Your Rights",
  privacyRightsText: "Under GDPR, you have the right to:",
  privacyRights1: "Access, rectify, or erase your personal data.",
  privacyRights2: "Restrict or object to processing.",
  privacyRights3: "Withdraw consent at any time.",
  privacyRights4: "Data portability.",
  privacyRightsContact: "To exercise your rights, contact us at:",
  privacyThirdParty: "8. Third-Party Links",
  privacyThirdPartyText: "Our website may contain links to third-party websites. We are not responsible for the privacy practices of these sites.",
  privacyUpdates: "9. Updates to This Policy",
  privacyUpdatesText: "We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated date.",

  // Common
  loading: "Loading...",
  error: "Error",
  success: "Success",
};
